import { TAILORING_AUDIT_TYPE } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/server/tailoring-audit-constants.mjs"
import { AuditEntryBoxBelow, TaskRowAfterEntry } from "slot-definitions"
import { RejectionReason } from "./rejection-reason"
import { and } from "lib/logic"
import { isTailoredScheduleAuditingEnabled } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/lib/is-tailored-schedule-auditing-enabled"
import { isTailoringEvent } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/lib/is-tailoring-event"
import { TailoringRejection } from "./tailoring-rejection"
import { ChangedTaskBelow, ChangedTaskEnd } from "routes/asset-register/plugins/general-tailoring/changed-task"
import { OkCancelButtonsBefore } from "lib/@components/okCancel"
import { RejectTailoringButton } from "./reject-tailoring-button"
import { RemoveRejection } from "./remove-rejection"
import { notSharing } from "routes/facilities/lib/when-parent-item"

AuditEntryBoxBelow(TAILORING_AUDIT_TYPE).plug(
    <RejectionReason if={and(isTailoredScheduleAuditingEnabled, (c) => isTailoringEvent(c.auditProps?.payload))} />
)

TaskRowAfterEntry.plug(
    <TailoringRejection
        if={and(isTailoredScheduleAuditingEnabled, (c) => !!c.editExtension, notSharing)}
        priority={200}
    />
)
ChangedTaskEnd.plug(<RejectTailoringButton if={isTailoredScheduleAuditingEnabled} priority={200} />)
ChangedTaskBelow.plug(<TailoringRejection if={isTailoredScheduleAuditingEnabled} priority={200} />)
OkCancelButtonsBefore.plug(<RemoveRejection if={isTailoredScheduleAuditingEnabled} />)
